import { ReactNode } from 'react';
import { Paper, Typography } from '@mui/material';

interface IProps {
  /** The form's submit button. */
  children: ReactNode;
}

/**
 * The bar the submit button lives in. It sticks to the bottom of the viewport
 * so a long form never hides the way forward, and it says up front that
 * submitting opens a review rather than acquiring the lead.
 */
const AcquisitionFormActions = ({ children }: IProps) => (
  <Paper
    variant="outlined"
    sx={{
      position: 'sticky',
      bottom: 0,
      zIndex: 1,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      flexWrap: 'wrap',
      gap: 2,
      px: 3,
      py: 2,
      boxShadow: '0 -4px 12px rgba(16, 60, 85, 0.06)',
    }}
  >
    <Typography variant="body2" color="text.secondary">
      Prima dell&apos;invio potrai verificare i dati inseriti.
    </Typography>
    {children}
  </Paper>
);

export default AcquisitionFormActions;
